<template>
  <div class="head">
    <span class="titleText">{{ $t('coordinationParticipant.audioSetting') }}</span>
    <i class="iconfont icon-Cancel pointer" @click="visibleChange()"></i>
  </div>
</template>
<script>
export default {
  methods: {
    visibleChange () {
      this.$emit('visibleChange', false)
    }
  }
}
</script>
<style lang="less" scoped>
.head {
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  padding-bottom: 24px;
  justify-content: space-between;
  border-bottom: 1px solid #434343;
  .titleText {
    color: #fff;
    font-size: 20px;
    font-weight: 600;
  }
  .icon-Cancel {
    font-size: 12px;
    color: #dbdbdb;
  }
}
</style>
